import styled from "styled-components";
import {
  fontWeightBold,
  h3Regular,
} from "../../../../components/typography/MuiTypography.style";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ConfirmatoryPopupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.cirrus_white};

  .confirmatory-message {
    line-height: 20px;
    color: ${COLORS.cirrus_black10};
  }
`;

export const UploadDocumentModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.cirrus_white};

  .content {
    width: 100%;
    padding: 24px 16px;

    ${responsive.MOBILE`
          padding: 16px 16px 0 16px;
          overflow-x: hidden;
          width: 100%;
          box-sizing: border-box;
    
        .MuiFormControl-root,
        .MuiTextField-root {
          width: 100%;
          box-sizing: border-box;
        }
        
        &:first-child {
          padding-bottom: 16px;
        }
      
        `}
  }

  .separator {
    border-bottom: 1px dashed ${COLORS.cirrus_black5};
  }

  .contact-type-container {
    display: flex;
    flex-direction: row;
  }

  .checkbox-container {
    margin-top: 38.5px;
  }
  .MuiPickersInputBase-root,
  .MuiFormControl-root {
    width: -webkit-fill-available;
  }

  .other-effective-date {
    margin: 6px 0 8px 0;
  }

  .sow-contract-expiration-date,
  .sow-contract-effective-date {
    margin-bottom: 8px;
  }

  .header-title {
    margin: 0 0 0 16px;
  }

  .geo-scope-container {
    margin-top: 32px;
    ${responsive.MOBILE`
      margin-top: 16px;
    `}
  }

  .upload-date {
    background-color: ${COLORS.cirrus_black1};

    .MuiInputBase-root {
      border-radius: 8px;
    }
    .MuiInputAdornment-root {
      opacity: 0.5;
    }
  }

  .upload-document-notes {
    display: grid;
    grid-template-columns: 2fr 1fr;
    padding-bottom: 24px;

    ${responsive.MOBILE`
      grid-template-columns: 1fr;
      width: 100%;
      padding-bottom: 16px;
    `}
    .notes-input {
      .MuiInputBase-root {
        height: 100px;
        background: ${COLORS.cirrus_black1};
        padding: 0px;
      }
    }
  }
  .MuiFormHelperText-root {
    .error-icon {
      word-break: break-word;
    }
  }

  .sow-status .MuiSvgIcon-root {
    display: none;
  }

  .opportunity-id-container {
    position: relative;
  }

  .validate-link {
    ${h3Regular}
    ${fontWeightBold}
    position: absolute;
    top: 0px;
    text-decoration: underline;
    text-underline-offset: 4px;
    right: 0px;
    color: ${COLORS.primary_light_blue};
  }
`;
